import {get} from 'lodash';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/react-hooks';
import {setItem, MAB_PAYLOAD_ITEM} from '../../utils/sessionStorage';

const mabQuery = gql`
    query(
        $componentsReady: [MabComponentType]!
        $campaignFeature: CampaignFeature!
        $clientContext: SerpContext
    ) {
        judgeSerp(
            componentsReady: $componentsReady
            campaignFeature: $campaignFeature
            clientContext: $clientContext
        ) {
            result {
                component
                level
            }
            multiArmEventPayload {
                armId
                banditId
                campaignId
                context
                payloadId
            }
        }
    }
`;

export const storeSessionPayload = ({
    judgeSerp: {multiArmEventPayload = {}} = {}
} = {}) => {
    if (multiArmEventPayload && multiArmEventPayload.payloadId) {
        setItem(MAB_PAYLOAD_ITEM, JSON.stringify(multiArmEventPayload));
    }
};

export const fetchJudgeSerpDataCompleted = (data) => {
    storeSessionPayload(data);
};

export const useFetchJudgeSerpData = ({
    resultCount,
    isDatedSearch,
    deviceType,
    numFilters,
    percentBooked,
    adultsCount,
    childrenCount,
    isLoadingOrRedirecting
}) => {
    const {data} = useQuery(mabQuery, {
        skip: isLoadingOrRedirecting || !resultCount,
        variables: {
            componentsReady: [],
            campaignFeature: 'SERP_LEAD_COMPONENT',
            clientContext: {
                isDatedSearch,
                resultsSize: resultCount,
                deviceType,
                filterApplied: !!numFilters,
                percentBooked:
                    percentBooked && percentBooked.currentPercentBooked
                        ? percentBooked.currentPercentBooked
                        : 0,
                adults: adultsCount,
                children: childrenCount
            }
        },
        onCompleted: fetchJudgeSerpDataCompleted
    });

    return get(data, ['judgeSerp'], {});
};
